<template>
    <div class="warning-top-wrapper d-flex flex-column aling-items-end">
        <div class="position-relative container-xl">
            <div class="position-absolute warning-container-wrapper">
                <Warning
                    v-for="(item, index) in this.$store.getters.get_warnings_list" :key="index"
                    class="warning-margin"
                    :warning="item"
                    @close="this.removeWarning(item.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Warning from '@/components/service/Warning';

export default {
    components : {
        Warning
    },
    methods: {
        removeWarning(id) {
            this.$store.commit("REMOVE_WARNING", id);
        }
    }
}
</script>

<style lang="scss" scoped>
    .warning-top-wrapper {
        position: fixed;
        z-index: 15000;
        margin-top: 90px;
        left: 0;
        top: 0;
        height: 1px;
        width: 100%;
    }
  
    .warning-margin {
        margin-bottom: 20px;
    }
    .warning-container-wrapper {
        left: 0;
        right: 0;
    }
</style>